
import { FaqGroup, QA } from '@/types/api/app-configuration'
import { defineComponent, PropType, reactive } from 'vue'
import { findIndex, includes } from 'lodash-es'
import { trackReadFaq } from '@/core/services/tracking-service'

export default defineComponent({
  props: {
    group: {
      type: Object as PropType<FaqGroup>
    }
  },
  setup() {
    const state = reactive({
      selectedQA: [] as QA[]
    })

    const toggleQuestion = (question: QA) => {
      const index = findIndex(state.selectedQA, question)
      if(index === -1) {
        // eslint-disable-next-line no-unused-expressions
        state.selectedQA?.push(question)
        trackReadFaq(question.question)
      } else {
        // eslint-disable-next-line no-unused-expressions
        state.selectedQA?.splice(index, 1)
      }
    }
    const isVisibleAnswer = (question: QA) => includes(state.selectedQA, question)
    const chevronIcon = (question: QA) => isVisibleAnswer(question) ? 'chevron-up' : 'chevron-down'

    function beforeEnter (el: HTMLElement) {
      el.style.height = '0'
    }

    function enter(el: HTMLElement) {
      el.style.height = el.scrollHeight + 'px'
    }

    function beforeLeave(el: HTMLElement) {
      el.style.height = el.scrollHeight + 'px'
    }

    function leave(el: HTMLElement) {
      el.style.height = '0'
    }
    return {
      trackReadFaq,
      toggleQuestion,
      isVisibleAnswer,
      chevronIcon,
      beforeEnter,
      enter,
      beforeLeave,
      leave
    }
  }
})

